// extracted by mini-css-extract-plugin
export default {"root":"homeUser_root__IDmc4","user_root":"homeUser_user_root__k5RGR","iconBox":"homeUser_iconBox__FNoL2","name":"homeUser_name__QCkdZ"};